module.exports = __webpack_public_path__ + "media/ErrorWindow.364a0f6f985178021e206735ab77fe9c.svg";